/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2022 (original work) Open Assessment Technologies SA ;
 */

const timerModes = Object.freeze({
    /**
     * Client-controlled timers.
     * The time counting is all done on the server, but control lies with the client,
     * which can inform when to start or stop them.
     * The client will receive regular timer updates.
     * In general, the only time we want timers to run is while an item is loaded + open + visible + interactable.
     */
    client: 'client',

    /**
     * Server-controlled timers.
     * They will count down on the server continuously from the moment the delivery is launched.
     * The client will receive regular timer updates.
     * The client cannot stop or pause the timers, even in a timeout or modal situation.
     */
    server: 'server'
});

export default timerModes;
